import { Component, computed, inject, signal } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-community';
import { ScheduledTask } from '../../../shared/models/scheduled-task.model';
import { SchedulerService, SchedulerTaskActionType } from '../../../shared/services/scheduler.service';

@Component({
  standalone: false,
  selector: 'app-scheduler-table-actions',
  templateUrl: './scheduler-table-actions.component.html',
  styleUrls: ['./scheduler-table-actions.component.scss'],
})
export class SchedulerTableActionsComponent {
  // inject
  readonly schedulerService = inject(SchedulerService);

  // signals
  readonly currentRow = signal<ScheduledTask | null>(null);
  readonly hiddenMode = signal<boolean>(false);

  // computed
  readonly isStopButtonVisible = computed(() => {
    const task = this.currentRow();

    return !!task && SchedulerService.canStopTask(task);
  });

  readonly isPauseButtonVisible = computed(() => {
    const task = this.currentRow();

    return !!task && SchedulerService.canPauseTask(task);
  });

  readonly isResumeButtonVisible = computed(() => {
    const task = this.currentRow();

    return !!task && SchedulerService.canResumeTask(task);
  });

  readonly isHideButtonVisible = computed(() => {
    const task = this.currentRow();

    return !!task && SchedulerService.canHideTask(task);
  });

  agInit(params: ICellRendererParams): void {
    this.currentRow.set(params.data);
    this.hiddenMode.set(this.schedulerService.getHiddenMode('inactive'));
  }

  refresh(params: ICellRendererParams) {
    this.currentRow.set(params.data);
    this.hiddenMode.set(this.schedulerService.getHiddenMode('inactive'));
    return true;
  }

  onClick(clickedItem: SchedulerTaskActionType) {
    this.schedulerService.announceAction({ name: clickedItem, row: this.currentRow()!, column: 'action' });
  }
}
